import { useMediaQuery, useTheme } from '@mui/material';

const useIsTablet = () => {
    const theme = useTheme();
    return useMediaQuery(theme.breakpoints.down('md'));
};

export default useIsTablet;
